import React, { useState, useEffect } from 'react';
import { X, Cookie, Shield } from 'lucide-react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const recordCookieChoice = (kind) => axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/consents`, { kind }, { withCredentials: true }).catch(() => {});

export function CookieConsent() {
  const [showBanner, setShowBanner] = useState(false);
  
  useEffect(() => {
    // Check if user has already accepted/rejected cookies
    const cookieConsent = localStorage.getItem('brandstage_cookie_consent');
    if (!cookieConsent) {
      // Show banner after a short delay
      const timer = setTimeout(() => setShowBanner(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);
  
  const handleAccept = () => {
    localStorage.setItem('brandstage_cookie_consent', 'accepted');
    recordCookieChoice('cookies_accepted');
    localStorage.setItem('brandstage_cookie_consent_date', new Date().toISOString());
    setShowBanner(false);
  };
  
  const handleReject = () => {
    localStorage.setItem('brandstage_cookie_consent', 'rejected');
    recordCookieChoice('cookies_rejected');
    localStorage.setItem('brandstage_cookie_consent_date', new Date().toISOString());
    setShowBanner(false);
  };
  
  if (!showBanner) return null;
  
  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 md:p-6 transform transition-transform duration-300 ease-out">
      <div className="max-w-4xl mx-auto bg-zinc-900 border border-zinc-700 rounded-xl shadow-2xl shadow-black/50 p-5 md:p-6">
        <div className="flex flex-col md:flex-row gap-4 md:items-center">
          {/* Icon and Text */}
          <div className="flex-1">
            <div className="flex items-center gap-2 mb-2">
              <Cookie className="w-5 h-5 text-[#C41E3A]" />
              <h3 className="text-white font-semibold">Cookie Preferences</h3>
            </div>
            <p className="text-zinc-400 text-sm leading-relaxed">
              We use cookies to enhance your experience, analyze site traffic, and for marketing purposes. 
              By clicking &quot;Accept All&quot;, you consent to our use of cookies. 
              Read our{' '}
              <Link to="/cookies" className="text-[#C41E3A] hover:underline">Cookie Policy</Link>
              {' '}and{' '}
              <Link to="/privacy" className="text-[#C41E3A] hover:underline">Privacy Policy</Link>
              {' '}for more information.
            </p>
          </div>
          
          {/* Buttons */}
          <div className="flex flex-col sm:flex-row gap-2 md:flex-shrink-0">
            <button
              onClick={handleReject}
              className="px-5 py-2.5 bg-zinc-800 hover:bg-zinc-700 text-white rounded-lg font-medium transition-colors border border-zinc-600"
            >
              Reject All
            </button>
            <button
              onClick={handleAccept}
              className="px-5 py-2.5 bg-[#C41E3A] hover:bg-[#a01830] text-white rounded-lg font-medium transition-colors"
            >
              Accept All
            </button>
          </div>
        </div>
      </div>
      
    </div>
  );
}

export default CookieConsent;
